import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";

import { createRoot } from 'react-dom/client';
import App from './App';

import './styles/style.scss';

const root = createRoot(document.getElementById('root'));
root.render(<App />);